import React from 'react';
import { BenefitsRoutes as SdkBenefitsRoutes } from '@leagueplatform/benefits';

const WalletRoutes = React.lazy(() =>
  import('@leagueplatform/wallet').then((module) => ({
    default: module.WalletRoutes,
  })),
);

interface IBenefitsRoutesProps {
  isBenefitsLandingMasonryV2Enabled: boolean;
}

export const BenefitsRoutes = ({
  isBenefitsLandingMasonryV2Enabled,
}: IBenefitsRoutesProps) =>
  isBenefitsLandingMasonryV2Enabled ? <SdkBenefitsRoutes /> : <WalletRoutes />;
